import { render, staticRenderFns } from "./LandingLoggedIn.vue?vue&type=template&id=1ba2fc90"
import script from "./LandingLoggedIn.vue?vue&type=script&lang=js"
export * from "./LandingLoggedIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports